const WEBSOCKET_URL = (window) =>
  window.location.protocol + "//" + window.location.hostname + ":8092";
const FILE_UPLOAD_URL = (window) =>
  window.location.protocol +
  "//" +
  window.location.hostname +
  ":443/uploadexcel";

module.exports = {
  WEBSOCKET_URL,
  FILE_UPLOAD_URL,
};
